import PersonalInformationForm from './PersonalInformationForm'
export default PersonalInformationForm
